/*
Ashraf 09/19/2022 2698947782 fixed validation messages for custom window fields
Sohel 09/22/2022 2698947782 Custom Windows Feedback Modifications
Sohel 09/23/2022 2698947782 Fixed Custom Windows Feedback Changes
Ashraf 09/24/2022 2698947782 Fixed Custom Windows Bugs
Ashraf 09/24/2022 2698947782 fixed view only when reference is type
Ashraf 09/25/2022 2698947782 custom window fields drag and drop bug fixes
Ashraf 09/26/2022 2698947782 change label of reset buttons to reset
Sohel 09/26/2022 2698947782 Custom Windows ->Added Window Owner Field, columns to dashboard table,bugfixes
Ashraf 09/29/2022 2698947782 fixed bugs on add custom window
Ashraf 09/30/2022 2698947782 fixed ssn and phone format bugs
Ashraf 09/20/2022 2698947782 changed field name of db reference
Rajesh 10/01/2022 2698947782 fixed bugs in UDW
Ashraf 10/01/2022 2698947782 fixed custom window bugs
Ashraf 10/03/2022 2698947782 db reference validation appearance issue after save
Ashraf 10/06/2022 2698947782 fixed validation issue for minimum field
Ashraf 10/06/2022 2698947782 added comments to code, removed unusual code
Ashraf 10/15/2022 2698947782 Added custom windows code comments
suresh peddavoora 10/28/2022 2698947782  Added class names for chechboxes
Ashraf 11/09/2022 2698947782 Added typecode dropdown
Raghu 11/10/2022 2698947782  Is list fields UI styling changes and alignment Fixes
Sohel 05/29/2023 2698947782 Fixed Save button Disabled Issue
*/

import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {useRef} from 'react';
import {useSelector} from 'react-redux';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  TextField,
  Tooltip,
} from '@material-ui/core';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {Currency} from '../../../util/Currency';
import NumberFormat from 'react-number-format';
import DialogBox from './../../DialogBox/index';
import SearchDatabaseReference from './searchDatabaseReference/SearchDatabaseReference';
import GuiAutoComplete from '../../FormComponents/GuiAutoComplete';
import GuiTextField from '../../FormComponents/GuiTextField';

// add field form to define a custom field  (2699250881)

const Form = ({
  setFormData,
  formData,
  handleClose,
  dbRef,
  data,
  setEditable,
  editable,
  viewSet,
  field,
  windowId,
  windowNumber,
  isCopyRowData,
  udwView,
  isEditMode,
  rowData,
  isAddOpen,
  setNewLookupField,
  isEditOpen,
  oldFieldName,
  fieldOperation,
  maxSequence,
  editExisting,
  setMaxSequence,
  setFieldOperation,
  setOldFieldName,
  lookupValuesData,
  setLookupValuesData,
}) => {
  const [fieldType, setFieldType] = useState(null);
  const {reusableInputStyles} = useContext(ThemeContext);
  const [minLabel, setMinLabel] = useState('Minimum length');
  const [maxLabel, setMaxLabel] = useState('Maximum length');
  const [dataBaseReference, setDataBaseReference] = useState(false);
  const [dataBaseValue, setDataBaseValue] = useState('');
  const formRef = useRef();

  // closing reference popup (2699250881)
  const handleDataBaseSearch = () => {
    setDataBaseReference(false);
  };

  // handling field type state (2699250881)
  const handleFieldType = (value) => {
    setFieldType(value);
    if (value === 'Number' || value === 'Amount') {
      setMinLabel('Minimum value');
      setMaxLabel('Maximum value');
    } else {
      setMinLabel('Minimum length');
      setMaxLabel('Maximum length');
    }
  };

  // setting field type when editing a field (2699250881)
  useEffect(() => {
    if (data?.fieldType) {
      handleFieldType(data?.fieldType);
    }
  }, []);

  // setting initial value for minimum and maximum (2699250881)
  const getValue = (validations, type) => {
    const item =
      validations && validations.length > 0 && validations.filter((i) => i.type === type);
    if (item && item.length > 0 && item[0].params && item[0].params.length > 0) {
      return Number(item[0].params[0]);
    } else {
      return '';
    }
  };
  const [items, setItems] = useState(data?.listValue ? data?.listValue : []);
  const [item, setItem] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [view, setView] = useState(udwView || data?.displayOptions?.isEditable === 'N');
  const [isDropdownChecked, setIsDropdownChecked] = useState(data?.isList === 'Dropdown');

  const {typeCodeDropdownData} = useSelector(({userDefinedWindow}) => userDefinedWindow);

  const fieldTypeOptions = [
    {key: 'Amount', value: 'Amount'},
    {key: 'Date', value: 'Date'},
    {key: 'Number', value: 'Number'},
    {key: 'Reference', value: 'Reference'},
    {key: 'Phone', value: 'Phone'},
    {key: 'SSN', value: 'SSN'},
    {key: 'string', value: 'Text'},
    {key: 'Email', value: 'Email'},
  ];

  // setting initial value for field type (2699250881)
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.key === option || item?.typeCode === option) {
          label = item;
        }
      });
    return label;
  };

  // initial values for form (2699250881)
  const initialValues = {
    fieldLabel: data && data.fieldLabel ? data.fieldLabel : '',
    lookupField: data?.isLookUp ? data.isLookUp === 'Y' : false,
    fieldType:
      (data && data?.isList && data?.isList === 'Y') ||
      data?.fieldType === 'string' ||
      data?.fieldType === 'Text' ||
      data?.fieldType === 'text' ?
        getObject('string', fieldTypeOptions) :
        data && data.fieldType ?
          getObject(data.fieldType, fieldTypeOptions) :
          'none',
    minimum: data.validations ?
      getValue(data.validations, 'min') :
      fieldType === 'Amount' || fieldType === 'Number' ?
        null :
        '',
    maximum: data.validations ? getValue(data.validations, 'max') : '',
    mandatory: data && data.isMandatory ? data.isMandatory === 'Y' : false,
    viewOnly:
      data && data.displayOptions && data.displayOptions.isEditable ?
        data.displayOptions.isEditable === 'N' :
        false,
    auditTrail:
      data && data.additionalOptions && data.additionalOptions.isAuditTrail ?
        data.additionalOptions.isAuditTrail === 'Y' :
        false,
    auditNote:
      data && data.additionalOptions && data.additionalOptions.isAuditNote ?
        data.additionalOptions.isAuditNote === 'Y' :
        false,
    unique:
      data && data.displayOptions && data.displayOptions.isUnique ?
        data.displayOptions.isUnique === 'Y' :
        false,
    isList: data && data.isList ? data.isList === 'Y' : false,
    isDropdown: data && data.isList ? data.isList === 'Dropdown' : false,
    dataBaseReference: data && data.globalFieldName ? data.globalFieldName : '',
    list: '',
    typeCode:
      (data && data?.typeCode) || data?.isList === 'Dropdown' ?
        getObject(data?.typeCode ? data?.typeCode : data?.listValue[0], typeCodeDropdownData) :
        '',
  };

  // setting reference value when editing a field (2699250881)
  useEffect(() => {
    setDataBaseValue(data?.globalFieldName);
  }, [data]);

  // adding a field to the fields table (2699250881)
  const handleSubmit = (values) => {
    const fetchedFields = editable.length > 0 ? [...editable] : [];
    const filterFetchedData = editable.filter((item) => {
      return item.sequenceNo === data.sequenceNo;
    });
    const copyData = [...formData];
    const filteredData = formData.filter((item) => {
      return item.sequenceNo === data.sequenceNo;
    });
    const validations = [];

    // setting validations based on given configurations (2699250881)
    if (values.mandatory) {
      validations.push({
        type: 'required',
        params: [`${values.fieldLabel} is required`],
      });
    }
    if (values.minimum && values.fieldType?.key === 'string') {
      validations.push({
        type: 'min',
        params: [
          values.minimum,
          `${values.fieldLabel} cannot be less than ${values.minimum} characters`,
        ],
      });
    }
    if (
      values.maximum &&
      (values.fieldType?.key === 'Number' || values.fieldType?.key === 'Amount')
    ) {
      validations.push({
        type: 'max',
        params: [
          values.maximum,
          `${values.fieldLabel} cannot exceed ${values?.fieldType?.key === 'Amount' ? `$` : ''} ${
            values.maximum
          } ${values?.fieldType?.key === 'Number' ? `digits` : ''}`,
        ],
      });
    }
    if (
      values.minimum &&
      (values.fieldType?.key === 'Number' || values.fieldType?.key === 'Amount')
    ) {
      validations.push({
        type: 'min',
        params: [
          values.minimum,
          `${values.fieldLabel} cannot be less than ${
            values?.fieldType?.key === 'Amount' ? `$` : ''
          } ${values.minimum} ${values?.fieldType?.key === 'Number' ? `digits` : ''}`,
        ],
      });
    }
    if (values.fieldType?.key === 'Date') {
      validations.push({
        type: 'typeError',
        params: [`Invalid Date Format`],
      });
    }
    if (!values.mandatory || values.fieldType?.key === 'Date') {
      validations.push({
        type: 'nullable',
        params: [],
      });
    }
    if (values.maximum && values.fieldType?.key === 'string') {
      validations.push({
        type: 'max',
        params: [values.maximum, `${values.fieldLabel} cannot exceed ${values.maximum} characters`],
      });
    }
    if (values.fieldType?.key === 'Email') {
      validations.push({
        type: 'email',
        params: [`${values.fieldLabel} is invalid`],
      });
    }
    const getLabel = (value) => {
      if (value) {
        return 'Y';
      }
      return 'N';
    };

    // setting field payload wih entered values (2699250881)
    const formValues = {
      windowFieldId: data?.windowFieldId ? data?.windowFieldId : null,
      sequenceNo: filteredData.length > 0 ? filteredData[0].sequenceNo : copyData.length + 1,
      fieldLabel: values.fieldLabel,
      fieldType:
        values && values?.isDropdown ?
          'dropdown' :
          values && values?.isList ?
            'dropdown' :
            values.fieldType?.key === 'string' ?
              'Text' :
              values.fieldType?.key,
      validationType: values.isDropdown ?
        'mixed' :
        (values.fieldType?.key === 'string' || 'Number') && values.isList ?
          'mixed' :
          (values.fieldType?.key === 'string' ||
            values.fieldType?.key === 'Email' ||
            values.fieldType?.key === 'Phone' ||
            values.fieldType?.key === 'SSN') &&
          !values.isList ?
            'string' :
            values.fieldType?.key === 'Date' ?
              'date' :
              values.fieldType?.key === 'Amount' ?
                'number' :
                values.fieldType?.key === 'Number' ?
                  'string' :
                  null,
      lookupType: data?.lookupType ? data?.lookupType : '',
      isLookUp: values?.lookupField ? 'Y' : 'N',
      isActive: 'Y',
      isList: values.isList ? 'Y' : values?.isDropdown ? 'Dropdown' : 'N',
      listValue: items.length > 0 ? items : '',
      isMandatory: values.isEditable ? 'N' : getLabel(values.mandatory),
      validations: validations,
      globalFieldName: dataBaseValue ? dataBaseValue : '',
      typeCode: values?.typeCode ? values?.typeCode?.typeCode : '',
      maximumLength: values.maximum,
      minimumLength: values.minimum,
      displayOptions: {
        isExtended: getLabel(values.isExtended),
        isEditable: getLabel(!values.viewOnly),
        isUnique: getLabel(values.unique),
        isHidden: getLabel(values.isHidden),
      },
      additionalOptions: {
        isAuditNote: getLabel(values.auditNote),
        isAuditTrail: getLabel(values.auditTrail),
        isTrackChanges: getLabel(values.isTrackChanges),
      },
    };

    if (editExisting) {
      formValues.sequenceNo = data?.sequenceNo ? data?.sequenceNo : fetchedFields?.length + 1;
      formValues.oldFieldName = !data?.windowFieldId ? '' : oldFieldName ? oldFieldName : '';
      formValues.fieldOperation = data?.windowFieldId ? 'E' : fieldOperation ? fieldOperation : 'N';
    }

    if (filteredData.length > 0) {
      copyData.splice(filteredData[0]?.tableData?.id, 1, formValues);
    } else {
      copyData.push(formValues);
    }
    if (filterFetchedData.length > 0) {
      fetchedFields.splice(filterFetchedData[0]?.tableData?.id, 1, formValues);
    } else {
      fetchedFields.push(formValues);
    }
    setEditable(fetchedFields);
    setFormData(copyData);
    handleClose();
  };
  //   AMT, CHR, DRV, DTE, FN1-FN22, KEY, NBR, PRT, SSN
  const classes = reusableInputStyles();

  // used to prevent entering spaces in fields (2699250881)
  const handleKeyDown = (evt) => {
    if (['Enter', 'Tab', ','].includes(evt.key)) {
      evt.preventDefault();
      const value = item.trim();
      if (value) {
        setItems([...items, value]);
        setItem('');
      }
    }
  };

  // handling list item change for list field (2699250881)
  const handleItemChange = (e) => {
    setItem(e.target.value);
  };

  // handling delete list item for list field (2699250881)
  const handleDelete = (item) => {
    setItems(items.filter((i) => i !== item));
  };

  // revalidate after reference selection (2699250881)
  useEffect(() => {
    dataBaseValue && formRef?.current?.setFieldValue('dataBaseReference', dataBaseValue);
  }, [dataBaseValue]);

  // number formatter used for number field (2699250881)
  function NumberFormatter(props) {
    const {inputRef, onChange, ...other} = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        isNumericString
        decimalScale={0}
        allowNegative={false}
      />
    );
  }

  // checking if field label exist for validation (2699250881)
  const getFieldLabel = (value, data) => {
    const ar = [];
    const val = value?.toLowerCase()?.replaceAll(' ', '');
    const editLabel = rowData?.fieldLabel?.toLowerCase()?.replaceAll(' ', '');
    data &&
      data?.map((i) => {
        if (isEditMode && val !== editLabel) {
          i?.fieldLabel?.toLowerCase()?.replaceAll(' ', '') === val && ar.push(i);
        } else if (!isEditMode) {
          i?.fieldLabel?.toLowerCase()?.replaceAll(' ', '') === val && ar.push(i);
        }
      });
    return ar.length > 0;
  };

  // validations for form fields (2699250881)
  const schema = Yup.object().shape(
    {
      fieldLabel:
        !windowNumber || isCopyRowData ?
          Yup.string()
            .test('fieldLabel', 'Field label already exist', (value) => {
              if (value && value.length > 0 && getFieldLabel(value, formData)) {
                return false;
              } else {
                return true;
              }
            })
            .required('Field label is required') :
          Yup.string()
            .test('fieldLabel', 'Field label already exist', (value) => {
              if (value && value.length > 0 && getFieldLabel(value, editable)) {
                return false;
              } else {
                return true;
              }
            })
            .required('Field label is required'),
      fieldType:
        !isDropdownChecked &&
        Yup.mixed().test('fieldType', 'Field type is required', (value) => {
          if (!value?.value) {
            return false;
          } else {
            return true;
          }
        }),
      dataBaseReference:
        fieldType === 'Reference' &&
        !dataBaseValue &&
        Yup.string().test('dataBaseReference', 'Database reference is required', (val) => {
          return dataBaseValue;
        }),
      maximum: Yup.number().when('minimum', (minimum, schema) => {
        return minimum > 0 ?
          schema.min(Yup.ref('minimum'), `${maxLabel} cannot be less than ${minLabel}`) :
          schema.nullable();
      }),
      minimum: Yup.number().when('maximum', {
        is: (value) => value && value.toString().length > 0,
        then: Yup.number()
          .test('minimum', `${minLabel} is required`, (value) => {
            if (value !== 0 && !value) {
              return false;
            } else {
              return true;
            }
          })
          .typeError(`${minLabel} is required`),
        otherwise: Yup.number().nullable(),
      }),
      list: Yup.object()
        .test('list', 'List is required', function(value, context) {
          const {parent} = context;
          if (parent.isList === true && items?.length < 1) {
            return false;
          } else {
            return true;
          }
        })
        .nullable(),
      typeCode: Yup.object()
        .test('typeCode', 'Type is required', function(value, context) {
          const {parent} = context;
          if (parent.isDropdown && !parent?.typeCode?.typeCode) {
            return false;
          } else {
            return true;
          }
        })
        .nullable(),
    },
    ['maximum', 'minimum', 'list', 'typeCode'],
  );
  useEffect(() => {
    setDisableSubmit(false);
  }, []);
  return (
    <div className={classes.dialoguecardStyles}>
      <Formik
        onSubmit={(values) => {
          setDisableSubmit(true);
          handleSubmit(values);
        }}
        innerRef={formRef}
        onReset={(values) => {
          if (data.fieldType === 'Number' || data.fieldType === 'Amount') {
            setMinLabel('Minimum Value');
            setMaxLabel('Maximum Value');
          } else {
            setMinLabel('Minimum length');
            setMaxLabel('Maximum length');
          }
          setFieldType(isEditOpen ? data.fieldType : null);
          setItems(data?.listValue ? data?.listValue : []);
          setItem('');
          values = initialValues;
        }}
        initialValues={initialValues}
        validationSchema={schema}
      >
        {(props) => {
          const {
            values,
            handleChange,
            handleSubmit,
            handleBlur,
            handleReset,
            setFieldValue,
            touched,
            setFieldTouched,
            errors,
          } = props;
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
              <div className="form-row global-field-textfields">
                <div className="form-group col-sm-4">
                  <TextField
                    margin="dense"
                    variant="outlined"
                    className={` ${classes.labelName} ${classes.inputLabel}`}
                    placeholder={`Enter Field Label`}
                    label="Field Label"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="fieldLabel"
                    value={values.fieldLabel}
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.fieldLabel}
                    error={Boolean(touched.fieldLabel && errors.fieldLabel)}
                  />
                  <FormHelperText>{touched.fieldLabel && errors.fieldLabel}</FormHelperText>
                </div>
                {!values?.isDropdown && (
                  <div className="form-group col-sm-4">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="fieldType"
                      size="small"
                      options={fieldTypeOptions}
                      fullWidth
                      className="select-gender"
                      label="Field Type"
                      required
                      value={values.fieldType || 'none'}
                      onBlur={handleBlur}
                      getOptionLabel={(option) => option.value}
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="fieldType"
                          error={Boolean(touched?.fieldType && errors?.fieldType)}
                          required
                          label="Field Type"
                          className={` ${classes.labelName} ${classes.selectLabel}`}
                          variant="outlined"
                          margin="dense"
                          placeholder="Select Field Type"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                          }}
                        />
                      )}
                      error={touched?.fieldType && errors?.fieldType}
                      touched={touched?.fieldType}
                      onChange={(event, value) => {
                        setFieldValue('fieldType', value).then(() => {
                          values.fieldType === 'none' && setFieldValue('fieldType', value);
                          handleFieldType(value?.value);
                          setFieldValue('isList', false);
                          setFieldValue('lookupField', false);
                          setFieldValue('minimum', '');
                          setFieldValue('maximum', '');
                          setItems([]);
                          if (!udwView) {
                            setView(false);
                            setFieldValue('viewOnly', false);
                          }
                          if (value?.value === 'Reference') {
                            setFieldValue('viewOnly', true) && setView(true);
                            setFieldValue('unique', false);
                          }
                          if (data && Object.keys(data).length > 0) {
                            data['fieldType'] = value?.value;
                            value?.value !== 'Reference' &&
                              setFieldValue('dataBaseReference', '') &&
                              (data['globalFieldName'] = '');
                          }
                        });
                      }}
                    />
                    {errors?.fieldType ? (
                      <FormHelperText>{touched.fieldType && errors.fieldType}</FormHelperText>
                    ) : null}
                  </div>
                )}
                {!(
                  // render maximum, minimum fields only for number, amount type (2699250881)
                  (
                    fieldType === 'Date' ||
                    fieldType === 'SSN' ||
                    fieldType === 'Reference' ||
                    fieldType === 'Email' ||
                    fieldType === 'Phone'
                  )
                ) &&
                  !(
                    data?.fieldType === 'Date' ||
                    data?.fieldType === 'SSN' ||
                    data?.fieldType === 'Reference' ||
                    data?.fieldType === 'Email' ||
                    data?.fieldType === 'Phone'
                  ) &&
                  !values?.isList && (
                  <>
                    {!view && !values?.isDropdown && (
                      <div className="form-group col-sm-4">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          className={
                            fieldType === 'Amount' ?
                                `${classes.labelName} ${classes.inputLabel} ${classes.amountLabel}` :
                                `${classes.labelName} ${classes.inputLabel}`
                          }
                          placeholder={`Enter ${minLabel}`}
                          label={minLabel}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: fieldType === 'Amount' && (
                              <InputAdornment position="start">$</InputAdornment>
                            ),
                            inputComponent: fieldType === 'Amount' ? Currency : NumberFormatter,
                          }}
                          name="minimum"
                          value={values.minimum}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.minimum}
                          error={Boolean(errors.minimum)}
                        />
                        <FormHelperText>{errors.minimum}</FormHelperText>
                      </div>
                    )}
                    {!view && !values?.isDropdown && (
                    // render if not view only field (2699250881)
                      <div className="form-group col-sm-4 adduser-password-fields">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          className={
                            fieldType === 'Amount' ?
                                `${classes.labelName} ${classes.inputLabel} ${classes.amountLabel}` :
                                `${classes.labelName} ${classes.inputLabel}`
                          }
                          placeholder={`Enter ${maxLabel}`}
                          label={maxLabel}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: fieldType === 'Amount' && (
                              <InputAdornment position="start">$</InputAdornment>
                            ),
                            inputComponent: fieldType === 'Amount' ? Currency : NumberFormatter,
                          }}
                          onKeyDown={() => setFieldTouched('maximum')}
                          name="maximum"
                          value={values.maximum}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.maximum}
                          error={Boolean(touched.maximum && errors.maximum)}
                        />
                        <FormHelperText>{touched.maximum && errors.maximum}</FormHelperText>
                      </div>
                    )}
                  </>
                )}
                {!(values?.fieldType?.value === 'Reference') && (
                  // render for every field except reference (2699250881)
                  <div className="form-group col-sm-4 global-fields-checkbox">
                    <Tooltip title="Additional types of lookups for finding an account">
                      <FormControl component="fieldset">
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(e, value) => {
                                handleChange(e);
                                setFieldValue('lookupField', e.target.checked);
                              }}
                              name="lookupField"
                              checked={values?.lookupField}
                              color="primary"
                            />
                          }
                          label="Lookup"
                          labelPlacement="end"
                        />
                      </FormControl>
                    </Tooltip>
                  </div>
                )}
                {fieldType === 'Reference' && (
                  // render for field type reference (2699250881)
                  <>
                    <div className="form-group col-sm-4">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Search Reference`}
                        label="Reference"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        name="dataBaseReference"
                        value={dataBaseValue}
                        required
                        onChange={(e) => {
                          handleChange(e);
                          setDataBaseValue(e.target.value);
                          setFieldValue('dataBaseReference', e.target.value);
                        }}
                        InputProps={{
                          endAdornment: (
                            <Button
                              variant="contained"
                              className={` ${classes.filterGroupButton}`}
                              onClick={() => setDataBaseReference(true)}
                            >
                              Search
                            </Button>
                          ),
                        }}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched['dataBaseReference']}
                        error={
                          touched && touched['dataBaseReference'] && errors['dataBaseReference']
                        }
                        helperText={
                          touched['dataBaseReference'] &&
                          errors['dataBaseReference'] &&
                          errors['dataBaseReference']
                        }
                      />
                      <FormHelperText>
                        {touched['dataBaseReference'] && errors['dataBaseReference']}
                      </FormHelperText>
                    </div>
                  </>
                )}
                {
                  <>
                    {!view &&
                      !values?.isDropdown &&
                      !(
                        fieldType === 'Date' ||
                        fieldType === 'SSN' ||
                        fieldType === 'Reference' ||
                        fieldType === 'Amount' ||
                        fieldType === 'Phone'
                      ) &&
                      !(
                        data?.fieldType === 'Date' ||
                        data?.fieldType === 'SSN' ||
                        data?.fieldType === 'Reference' ||
                        data?.fieldType === 'Amount' ||
                        data?.fieldType === 'Phone'
                      ) && (
                    // render for type dropdown (2699250881)
                      <div className="col-sm-4 custom-list-checkbox form-group global-fields-checkbox">
                        <Tooltip title="User should enter an original value for a specified field">
                          <FormControl component="fieldset">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={(e, value) => {
                                    handleChange(e);
                                    setFieldValue('isList', e.target.checked);
                                    if (e?.target?.checked) {
                                      setFieldValue(
                                        'minimum',
                                        fieldType === 'Amount' || fieldType === 'Number' ?
                                          null :
                                          '',
                                      );
                                      setFieldValue('maximum', '');
                                    }
                                  }}
                                  name="isList"
                                  checked={values.isList}
                                  color="primary"
                                />
                              }
                              label="Is List"
                              labelPlacement="end"
                            />
                          </FormControl>
                        </Tooltip>
                      </div>
                    )}
                    {values.isList && (
                      <div className="col-sm-8 chips-block">
                        {items.map((item) => (
                          <div key={item}>
                            <div className="tag-item-chips" key={item}>
                              <div className="chips-content">{item}</div>
                              <button
                                type="button"
                                className="chips-close"
                                onClick={() => handleDelete(item)}
                              >
                                &times;
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {values.isList && (
                      <div className="form-group col-sm-12">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder={`Enter List`}
                          label="List"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="list"
                          required
                          InputProps={{
                            onKeyDown: handleKeyDown,
                          }}
                          value={item}
                          onChange={(e, val) => {
                            handleChange(e);
                            setFieldValue('list', e.target.value);
                            handleItemChange(e);
                          }}
                          onBlur={handleBlur}
                          fullWidth
                          error={items?.length < 1 && touched.list && errors.list}
                        />
                        {items?.length < 1 && (
                          <FormHelperText>
                            {touched.list && errors.list && errors.list}
                          </FormHelperText>
                        )}
                      </div>
                    )}
                    {!view &&
                      !values?.isList &&
                      !(
                        fieldType === 'Date' ||
                        fieldType === 'SSN' ||
                        fieldType === 'Reference' ||
                        fieldType === 'Amount' ||
                        fieldType === 'Phone'
                      ) &&
                      !(
                        data?.fieldType === 'Date' ||
                        data?.fieldType === 'SSN' ||
                        data?.fieldType === 'Reference' ||
                        data?.fieldType === 'Amount' ||
                        data?.fieldType === 'Phone'
                      ) && (
                      <div className="col-sm-4 custom-list-checkbox form-group global-fields-checkbox">
                        <Tooltip title="">
                          <FormControl component="fieldset">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  disabled={values?.isList}
                                  onChange={(e, value) => {
                                    handleChange(e);
                                    // setFieldValue("isList", e.target.checked);
                                    // if (e?.target?.checked) {
                                    //   setFieldValue(
                                    //     "minimum",
                                    //     fieldType === "Amount" || fieldType === "Number"
                                    //       ? null
                                    //       : ""
                                    //   );
                                    // }
                                    setFieldValue('maximum', '');
                                    setFieldValue('minimum', '');
                                    setIsDropdownChecked(e.target.checked);
                                  }}
                                  name="isDropdown"
                                  checked={values.isDropdown}
                                  color="primary"
                                />
                              }
                              label="Is Dropdown"
                              labelPlacement="end"
                            />
                          </FormControl>
                        </Tooltip>
                      </div>
                    )}
                    {values.isDropdown && (
                      <div className="form-group col-sm-12">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="typeCode"
                          size="small"
                          options={typeCodeDropdownData?.length > 0 ? typeCodeDropdownData : []}
                          fullWidth
                          className="select-gender"
                          label="Type Code"
                          required
                          value={values?.typeCode}
                          onBlur={handleBlur}
                          getOptionLabel={(option) =>
                            option?.typeCode && option?.description ?
                              `${option?.typeCode} - ${option?.description}` :
                              option?.typeCode ?
                                option?.typeCode :
                                null
                          }
                          renderInput={(params) => (
                            <GuiTextField
                              {...params}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              name="typeCode"
                              error={Boolean(touched?.typeCode && errors?.typeCode)}
                              required
                              label="Type"
                              className={` ${classes.labelName} ${classes.selectLabel}`}
                              variant="outlined"
                              margin="dense"
                              placeholder="Select Type"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off', // disable autocomplete and autofill
                              }}
                            />
                          )}
                          error={touched?.typeCode && errors?.typeCode}
                          touched={touched?.typeCode}
                          onChange={(event, value) => {
                            setFieldValue('typeCode', value);
                          }}
                        />
                        {errors?.typeCode ? (
                          <FormHelperText>{touched.typeCode && errors.typeCode}</FormHelperText>
                        ) : null}
                      </div>
                    )}
                    {!view && fieldType !== 'Reference' && (
                      // rendering mandatory field if not view only, type reference (2699250881)
                      <div className="col-sm-4 global-fields-checkbox">
                        <Tooltip title="To make field Mandatory">
                          <FormControl component="fieldset">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={(e, value) => {
                                    handleChange(e);
                                    setFieldValue('mandatory', e.target.checked);
                                    if (e.target.checked) {
                                      setFieldValue('viewOnly', false);
                                    }
                                    if (!e.target.checked) {
                                      setFieldValue('unique', false);
                                    }
                                  }}
                                  name="mandatory"
                                  checked={values.mandatory}
                                  color="primary"
                                />
                              }
                              label="Mandatory"
                              labelPlacement="end"
                            />
                          </FormControl>
                        </Tooltip>
                      </div>
                    )}
                    {!udwView && (
                      // rendering view only checkbox if its not view only window (2699250881)
                      <>
                        <div className="col-sm-4 global-fields-checkbox">
                          <Tooltip title="Field can only be viewed">
                            <FormControl component="fieldset">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={(e, value) => {
                                      setFieldValue('minimum', '');
                                      setFieldValue('maximum', '');
                                      handleChange(e);
                                      setView(e.target.checked);
                                      setFieldValue('viewOnly', e.target.checked);
                                      if (e.target.checked) {
                                        setFieldValue('mandatory', false);
                                      }
                                    }}
                                    name="viewOnly"
                                    checked={values.viewOnly}
                                    color="primary"
                                  />
                                }
                                disabled={values?.fieldType?.key === 'Reference'}
                                label="View Only"
                                labelPlacement="end"
                              />
                            </FormControl>
                          </Tooltip>
                        </div>
                        {!(values?.fieldType?.value === 'Reference') && (
                          // render audit trail checkbox if field type is not reference (2699250881)
                          <>
                            <div className="col-sm-4 global-fields-checkbox">
                              <Tooltip title="Tracks changes to data stored">
                                <FormControl component="fieldset">
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        onChange={handleChange}
                                        name="auditTrail"
                                        checked={values.auditTrail}
                                        color="primary"
                                      />
                                    }
                                    label="Audit Trail"
                                    labelPlacement="end"
                                  />
                                </FormControl>
                              </Tooltip>
                            </div>
                            <div className="col-sm-4 global-fields-checkbox">
                              <Tooltip title="System adds to an account when data is changed">
                                <FormControl component="fieldset">
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        onChange={handleChange}
                                        name="auditNote"
                                        checked={values.auditNote}
                                        color="primary"
                                      />
                                    }
                                    label="Audit Note"
                                    labelPlacement="end"
                                  />
                                </FormControl>
                              </Tooltip>
                            </div>
                          </>
                        )}
                        {!(values?.fieldType?.value === 'Reference') && (
                          // render audit trail checkbox if field type is not reference (2699250881)
                          <div className="col-sm-4 global-fields-checkbox">
                            <Tooltip title="User should enter an original value for a specified field">
                              <FormControl component="fieldset">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      onChange={(e) => {
                                        handleChange(e);
                                        setFieldValue('mandatory', true);
                                      }}
                                      name="unique"
                                      checked={values.unique}
                                      color="primary"
                                    />
                                  }
                                  label="Unique"
                                  labelPlacement="end"
                                />
                              </FormControl>
                            </Tooltip>
                          </div>
                        )}
                      </>
                    )}
                  </>
                }
              </div>
              <div className="button-spacing-mb">
                <Button
                  type="reset"
                  variant="outlined"
                  className={`reset-btn mx-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    if (isEditOpen) {
                      data['fieldType'] = field;
                      data['globalFieldName'] = dbRef;
                      data?.displayOptions?.isEditable === 'N' && setView(true);
                      setDataBaseValue(data?.globalFieldName);
                      data?.displayOptions?.isEditable === 'Y' && setView(false);
                    } else {
                      !udwView && setView(false);
                      setFieldType('');
                      setDataBaseValue('');
                    }
                  }}
                >
                  Reset
                </Button>
                <Button
                  type="submit"
                  disabled={disableSubmit}
                  variant="outlined"
                  className={`search-btn mx-1 ${classes.buttonRoot}`}
                >
                  {isAddOpen ? 'Save' : isEditOpen ? 'Save' : ''}
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      <DialogBox
        open={dataBaseReference}
        dialogClose={() => handleDataBaseSearch()}
        title="Add Database Reference"
        maxWidth="lg"
      >
        <SearchDatabaseReference
          handleClose={handleDataBaseSearch}
          setDataBaseValue={setDataBaseValue}
        />
      </DialogBox>
    </div>
  );
};

export default Form;
